import AbstractBulkClosedModel from 'uplisting-frontend/models/abstract-bulk-closed';

export default class BulkClosedForArrivalModel extends AbstractBulkClosedModel {}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'bulk-closed-for-arrival': BulkClosedForArrivalModel;
  }
}
